<template>
	<div>
		<card :has-height-medium="false" title="お知らせ" icon="comment-multiple-outline">
			<div class="info" v-for="(info, index) in informations" :key="index">
				{{ info.date }}&emsp;{{ info.body }}
			</div>
		</card>

		<card v-if="isDisplayUserTable" :has-height-medium="false" title="企業別利用数" icon="account-multiple">
			<dashboard-user-count-table :data="customers" :totalNum="customerTotalNum" :isLoading="isLoading" :checkable="false"/>
		</card>

		<card :has-height-medium="false" title="出勤状況" icon="calendar-clock">
			<div class="columns is-multiline">
				<div v-for="(shop, index) in wsShops" class="column is-one-third-tablet is-one-fifth-desktop">
					<card-widget :icon="shop.is_full ? 'check' : 'fire'" :is-trending="null" :state="shop.is_full ? 'success' : 'danger'" :number="shop.value" number-suffix="%">
						<template slot="label">
							{{ shop.name }}
						</template>
						<template slot="heading">
							出勤率
						</template>
					</card-widget>
				</div>
			</div>

			<b-table
				:data="workStatuses"
				:loading="isLoading"
				default-sort="shop"
				>

				<template slot-scope="props">
					<b-table-column field="shop_name" label="店舗名" sortable>
						{{ props.row.shop_name }}
					</b-table-column>

					<b-table-column field="schedule_start" label="開始" sortable>
						{{ props.row.schedule_start }}
					</b-table-column>

					<b-table-column field="start" label="出勤" sortable>
						<span v-if="props.row.is_not_working" class="has-text-danger"><i class="mdi mdi-fire"></i></span>
						<span v-else>{{ props.row.start }}</span>
					</b-table-column>

					<b-table-column field="staff_name" label="スタッフ名" sortable>
						{{ props.row.staff_name }}
					</b-table-column>

					<b-table-column :visible="isAi" field="smile" label="スマイル">
						<img class="smile-img" :src="props.row.smile" v-if="props.row.smile !== ''">
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<div class="content has-text-grey has-text-centered">
						<template v-if="isLoading">
						</template>
						<template v-else>
							<p>データはありません</p>
						</template>
					</div>
				</section>
			</b-table>
		</card>
	</div>
</template>

<script>
import Card from '@/components/Card'
import CardWidget from '@/components/CardWidget'
import UpdatesCardSample from '@/components/UpdatesCardSample'
import DashboardUserCountTable from '@/components/DashboardUserCountTable'

export default {
	name: 'dashboard',
	components: {
		Card,
		DashboardUserCountTable,
		CardWidget,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			informations: [],
			customers: [],
			workStatuses: [],
			wsShops: [],
			isAi: false,
		}
	},
	computed: {
		customerTotalNum: function() {
			return this.customers.length;
		},
		isDisplayUserTable: function() {
			return this.$store.state.auth.permissions.includes(4);
		},
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['ダッシュボード']
		});
	},
	methods: {
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;

			let ep = 'dashboards';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.informations = res.data.informations;
				this.customers = res.data.customers;
				this.workStatuses = res.data.work_statuses.list;
				this.wsShops = res.data.work_statuses.shops;
				this.isAi = res.data.is_ai;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>

<style scoped>
.info {
	border-bottom: #eee 1px solid;
	margin-left: -1.125rem;
	margin-right: -1.125rem;
	padding: 10px 20px;
}
.smile-img {
	width: 20px;
	height: auto;
}
</style>
